export type Member = { id: string; name: string; email?: string; role: 'athlete' | 'coach' | 'admin'; active?: boolean; mustChangePassword?: boolean };
export type Measurement = { id: string; memberId: string; date: string; test: string; value: number; unit: string; direction: 'higher' | 'lower'; notes: string };
export const numberFormat = new Intl.NumberFormat('hu-HU', { maximumFractionDigits: 4 });
export function seriesKey(row: Pick<Measurement, 'test'|'unit'|'direction'>) { return JSON.stringify([row.test, row.unit, row.direction]); }
export function orderedMeasurements(rows: Measurement[]) { return [...rows].sort((a,b)=>a.date.localeCompare(b.date)||a.id.localeCompare(b.id)); }
export function progress(rows: Measurement[]) {
 const sorted = orderedMeasurements(rows);
 if (sorted.length < 2) return null;
 const first = sorted[0].value, last = sorted.at(-1)!.value;
 const delta = (last-first)*(sorted[0].direction==='lower'?-1:1);
 return { delta, percent: first === 0 ? null : delta / Math.abs(first) * 100, improved: delta > 0 };
}
export function filterMeasurements(rows: Measurement[], memberId = '', key = '') {
 return rows.filter(row=>(!memberId||row.memberId===memberId)&&(!key||seriesKey(row)===key));
}
export function parseCSV(text: string): string[][] {
 text=text.replace(/^\uFEFF/,'');
 const firstLine=text.split(/\r?\n/)[0]||'';
 let quoted=false, semicolons=0, commas=0;
 for(let i=0;i<firstLine.length;i++){if(firstLine[i]==='"')quoted=!quoted;else if(!quoted){semicolons+=Number(firstLine[i]===';');commas+=Number(firstLine[i]===',')}}
 const delimiter=semicolons>commas?';':',';
 const rows:string[][]=[];let row:string[]=[];let cell='';quoted=false;
 for(let i=0;i<text.length;i++){
  const ch=text[i];
  if(ch==='"'){if(quoted&&text[i+1]==='"'){cell+='"';i++}else if(!quoted&&cell.length!==0)throw new Error('Hibás idézőjel a CSV-fájlban.');else quoted=!quoted}
  else if(!quoted&&ch===delimiter){row.push(cell);cell=''}
  else if(!quoted&&(ch==='\n'||ch==='\r')){if(ch==='\r'&&text[i+1]==='\n')i++;row.push(cell);if(row.some(v=>v.trim()))rows.push(row);row=[];cell=''}
  else cell+=ch;
 }
 if(quoted)throw new Error('Lezáratlan idézőjel a CSV-fájlban.');
 row.push(cell);if(row.some(v=>v.trim()))rows.push(row);
 return rows;
}
const columnNames=['email','datum','teszt','eredmeny','mertekegyseg','irany','megjegyzes'];
const normalize=(s:string)=>s.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[-_\s]/g,'');
export function importRows(table: string[][]) {
 if(table.length<2)throw new Error('A táblázatban nincs felmérési sor.');
 const header=table[0].map(normalize);
 const positions=columnNames.map(name=>header.indexOf(name));
 if(positions.slice(0,6).some(i=>i<0))throw new Error('Hiányzó oszlop. A mintafájl fejlécét használd.');
 if(table.length>501)throw new Error('Egyszerre legfeljebb 500 felmérés importálható.');
 return table.slice(1).map((row,index)=>{
  const get=(i:number)=>positions[i]<0?'':(row[positions[i]]||'').trim();
  const email=get(0), date=get(1), test=get(2), numeric=get(3), unit=get(4), arrow=normalize(get(5)), notes=get(6);
  const value=Number(numeric.replace(',','.'));
  const direction=['kisebb','lower','ido'].includes(arrow)?'lower':['nagyobb','higher'].includes(arrow)?'higher':null;
  if(!/^\S+@\S+\.\S+$/.test(email)||!validDate(date)||!test||!unit||!/^\+?(?:\d+(?:[.,]\d*)?|[.,]\d+)(?:e[+-]?\d+)?$/i.test(numeric)||!Number.isFinite(value)||value<0||value>1e9||!direction)
   throw new Error(`${index+2}. sor: hibás e-mail, dátum, teszt, eredmény, mértékegység vagy irány.`);
  return {email,date,test,value,unit,direction,notes};
 });
}
export function validDate(value:string) {
 if(!/^\d{4}-\d{2}-\d{2}$/.test(value))return false;
 const date=new Date(value+'T00:00:00Z');
 return Number.isFinite(date.getTime())&&date.toISOString().slice(0,10)===value&&Number(value.slice(0,4))>=1;
}
export function exportCSV(rows:Measurement[], members:Member[]) {
 const names=new Map(members.map(m=>[m.id,m.name]));
 const safe=(value:string)=>{if(/^[=+\-@\t\r]/.test(value))value="'"+value;return '"'+value.replaceAll('"','""')+'"'};
 return '\uFEFF'+[['Versenyző','Dátum','Teszt','Eredmény','Mértékegység','Irány','Megjegyzés'],...rows.map(r=>[names.get(r.memberId)||'',r.date,r.test,String(r.value).replace('.',','),r.unit,r.direction==='lower'?'kisebb':'nagyobb',r.notes])].map(row=>row.map(safe).join(';')).join('\r\n');
}
export function downloadText(name:string,text:string,type='text/csv;charset=utf-8') {
 const url=URL.createObjectURL(new Blob([text],{type})); const anchor=document.createElement('a');anchor.href=url;anchor.download=name;anchor.click();setTimeout(()=>URL.revokeObjectURL(url),1000);
}
